module.exports = __webpack_public_path__ + "media/efdab_1.1c.b244e7d2.mp3";